var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbles3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5259 12.9141C18.3031 12.9141 20.5545 10.6627 20.5545 7.88551C20.5545 5.1083 18.3031 2.85693 15.5259 2.85693C12.7487 2.85693 10.4973 5.1083 10.4973 7.88551C10.4973 10.6627 12.7487 12.9141 15.5259 12.9141Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5259 12.9141C18.3031 12.9141 20.5545 10.6627 20.5545 7.88551C20.5545 5.1083 18.3031 2.85693 15.5259 2.85693C12.7487 2.85693 10.4973 5.1083 10.4973 7.88551C10.4973 10.6627 12.7487 12.9141 15.5259 12.9141Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5259 12.9141C18.3031 12.9141 20.5545 10.6627 20.5545 7.88551C20.5545 5.1083 18.3031 2.85693 15.5259 2.85693C12.7487 2.85693 10.4973 5.1083 10.4973 7.88551C10.4973 10.6627 12.7487 12.9141 15.5259 12.9141Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6116 3.91961C17.1773 4.78247 16.4916 6.2339 15.0802 7.1539C13.6688 8.0739 12.0688 8.13104 11.503 7.26819C10.9373 6.40533 11.623 4.9539 13.0345 4.0339C14.4459 3.1139 16.0459 3.05676 16.6116 3.91961Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5259 12.9141C18.3031 12.9141 20.5545 10.6627 20.5545 7.88551C20.5545 5.1083 18.3031 2.85693 15.5259 2.85693C12.7487 2.85693 10.4973 5.1083 10.4973 7.88551C10.4973 10.6627 12.7487 12.9141 15.5259 12.9141Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9146 10.5372C12.6746 9.88003 10.8517 7.83431 11.3374 5.09717C10.806 5.89717 10.4917 6.85145 10.4917 7.88574C10.4917 10.6629 12.7431 12.9143 15.5203 12.9143C16.766 12.9143 17.9088 12.4572 18.7888 11.7086C17.126 10.5429 16.2003 11.7543 13.9146 10.5372Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6858 2.86279C15.7601 2.86851 15.8286 2.87994 15.9029 2.89708C16.0229 2.93136 16.1429 2.98279 16.2572 3.04565C16.4801 3.17708 16.6686 3.35422 16.8401 3.54851C17.1715 3.94279 17.4058 4.40565 17.5829 4.88565C17.6744 5.12565 17.7486 5.37136 17.8115 5.61708C17.8744 5.86279 17.9258 6.11422 17.9658 6.36565C18.0058 6.61708 18.0344 6.86851 18.0572 7.12565C18.0744 7.37708 18.0858 7.63422 18.0858 7.89136C18.0858 8.1485 18.0744 8.39993 18.0572 8.65708C18.0344 8.9085 18.0115 9.16565 17.9658 9.41708C17.9258 9.6685 17.8744 9.91993 17.8115 10.1656C17.7486 10.4114 17.6744 10.6571 17.5829 10.8971C17.4058 11.3714 17.1658 11.8342 16.8401 12.2342C16.6744 12.4285 16.4801 12.6056 16.2572 12.7371C16.1486 12.7999 16.0286 12.8514 15.9029 12.8856C15.8344 12.9028 15.7601 12.9142 15.6915 12.9199C17.5086 12.7942 18.9544 10.5942 18.9544 7.89708C18.9544 5.18851 17.5029 2.98851 15.6858 2.86279Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97157 16.7483C8.92824 16.7483 10.5144 15.1621 10.5144 13.2055C10.5144 11.2488 8.92824 9.6626 6.97157 9.6626C5.0149 9.6626 3.42871 11.2488 3.42871 13.2055C3.42871 15.1621 5.0149 16.7483 6.97157 16.7483Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97157 16.7483C8.92824 16.7483 10.5144 15.1621 10.5144 13.2055C10.5144 11.2488 8.92824 9.6626 6.97157 9.6626C5.0149 9.6626 3.42871 11.2488 3.42871 13.2055C3.42871 15.1621 5.0149 16.7483 6.97157 16.7483Z",
    fill: "url(#paint8_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97157 16.7483C8.92824 16.7483 10.5144 15.1621 10.5144 13.2055C10.5144 11.2488 8.92824 9.6626 6.97157 9.6626C5.0149 9.6626 3.42871 11.2488 3.42871 13.2055C3.42871 15.1621 5.0149 16.7483 6.97157 16.7483Z",
    fill: "url(#paint9_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73724 10.4168C8.13725 11.0225 7.65153 12.0454 6.65724 12.6968C5.66296 13.3482 4.53153 13.3825 4.13724 12.7768C3.73724 12.1711 4.22296 11.1482 5.21724 10.4968C6.21153 9.84535 7.33724 9.81106 7.73724 10.4168Z",
    fill: "url(#paint10_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97157 16.7483C8.92824 16.7483 10.5144 15.1621 10.5144 13.2055C10.5144 11.2488 8.92824 9.6626 6.97157 9.6626C5.0149 9.6626 3.42871 11.2488 3.42871 13.2055C3.42871 15.1621 5.0149 16.7483 6.97157 16.7483Z",
    fill: "url(#paint11_radial)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83443 15.074C4.96014 14.6112 3.68014 13.1712 4.023 11.2397C3.64585 11.8055 3.42871 12.4797 3.42871 13.2055C3.42871 15.1597 5.01728 16.7483 6.97157 16.7483C7.85157 16.7483 8.65728 16.4283 9.27443 15.8969C8.103 15.0797 7.44585 15.9312 5.83443 15.074Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08594 9.66846C7.13737 9.67417 7.18879 9.67989 7.23451 9.69131C7.32022 9.71417 7.40594 9.75417 7.48022 9.79417C7.63451 9.8856 7.77165 10.0113 7.89165 10.1485C8.12594 10.4285 8.29165 10.7542 8.41737 11.0913C8.48023 11.257 8.53737 11.4342 8.57737 11.6056C8.62308 11.777 8.65737 11.9542 8.68594 12.1313C8.71451 12.3085 8.73165 12.4856 8.7488 12.6685C8.76023 12.8456 8.76594 13.0285 8.77165 13.2056C8.77165 13.3827 8.76594 13.5656 8.7488 13.7427C8.73165 13.9199 8.71451 14.1027 8.68594 14.2799C8.65737 14.457 8.61737 14.6342 8.57737 14.8056C8.53165 14.9827 8.48023 15.1542 8.41737 15.3199C8.29165 15.657 8.12594 15.9827 7.89165 16.2627C7.77165 16.3999 7.64022 16.5256 7.48022 16.617C7.40022 16.6627 7.32022 16.697 7.23451 16.7199C7.18308 16.7313 7.13737 16.7427 7.08594 16.7427C8.36594 16.6513 9.3888 15.1027 9.3888 13.2056C9.3888 11.3085 8.36594 9.75989 7.08594 9.66846Z",
    fill: "url(#paint13_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 21.1425C17.0066 21.1425 18.2858 19.8633 18.2858 18.2854C18.2858 16.7074 17.0066 15.4282 15.4287 15.4282C13.8507 15.4282 12.5715 16.7074 12.5715 18.2854C12.5715 19.8633 13.8507 21.1425 15.4287 21.1425Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 21.1425C17.0066 21.1425 18.2858 19.8633 18.2858 18.2854C18.2858 16.7074 17.0066 15.4282 15.4287 15.4282C13.8507 15.4282 12.5715 16.7074 12.5715 18.2854C12.5715 19.8633 13.8507 21.1425 15.4287 21.1425Z",
    fill: "url(#paint15_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 21.1425C17.0066 21.1425 18.2858 19.8633 18.2858 18.2854C18.2858 16.7074 17.0066 15.4282 15.4287 15.4282C13.8507 15.4282 12.5715 16.7074 12.5715 18.2854C12.5715 19.8633 13.8507 21.1425 15.4287 21.1425Z",
    fill: "url(#paint16_radial)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0459 16.0339C16.3659 16.5253 15.9774 17.3482 15.1774 17.8739C14.3774 18.3996 13.4631 18.4282 13.1431 17.9367C12.8231 17.4453 13.2117 16.6224 14.0117 16.0967C14.8116 15.571 15.7259 15.5424 16.0459 16.0339Z",
    fill: "url(#paint17_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 21.1425C17.0066 21.1425 18.2858 19.8633 18.2858 18.2854C18.2858 16.7074 17.0066 15.4282 15.4287 15.4282C13.8507 15.4282 12.5715 16.7074 12.5715 18.2854C12.5715 19.8633 13.8507 21.1425 15.4287 21.1425Z",
    fill: "url(#paint18_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5144 19.7941C13.8115 19.4226 12.7772 18.2569 13.0515 16.7026C12.7487 17.1541 12.5715 17.7026 12.5715 18.2855C12.5715 19.8626 13.8515 21.1426 15.4287 21.1426C16.1373 21.1426 16.7887 20.8855 17.2858 20.4569C16.3373 19.7941 15.8115 20.4855 14.5144 19.7941Z",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 15.4341C15.56 15.4398 15.6 15.4455 15.64 15.4569C15.7086 15.4798 15.7772 15.5084 15.84 15.5427C15.9657 15.6169 16.0743 15.7198 16.1714 15.8284C16.36 16.0512 16.4914 16.3141 16.5943 16.5884C16.6457 16.7255 16.6914 16.8627 16.7257 17.0055C16.76 17.1484 16.7886 17.2855 16.8114 17.4284C16.8343 17.5712 16.8514 17.7141 16.8629 17.8569C16.8743 17.9998 16.88 18.1484 16.88 18.2912C16.88 18.4341 16.8743 18.5827 16.8629 18.7255C16.8514 18.8684 16.8343 19.0112 16.8114 19.1541C16.7886 19.2969 16.76 19.4398 16.7257 19.5769C16.6914 19.7198 16.6457 19.8569 16.5943 19.9941C16.4914 20.2627 16.36 20.5255 16.1714 20.7541C16.0743 20.8627 15.9657 20.9655 15.84 21.0398C15.7772 21.0741 15.7086 21.1027 15.64 21.1255C15.6 21.1369 15.56 21.1427 15.52 21.1484C16.5543 21.0741 17.3772 19.8284 17.3772 18.2969C17.3772 16.7541 16.5543 15.5027 15.52 15.4341Z",
    fill: "url(#paint20_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.0518,
    y1: 0.827464,
    x2: 29.1333,
    y2: 29.3637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1498 3.5623) scale(11.7727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FB9DC1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#F59EC3",
    stopOpacity: 0.0730316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    stopColor: "#E2A0C8",
    stopOpacity: 0.1749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#C5A4D0",
    stopOpacity: 0.2938
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9BAADB",
    stopOpacity: 0.4256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#66B1E9",
    stopOpacity: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9818,
    stopColor: "#26B9FA",
    stopOpacity: 0.7172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5347 7.96713) scale(13.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0581 5.59451) rotate(-33.2503) scale(2.53204 1.6835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5347 7.96713) scale(13.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15.7656,
    y1: 6.53475,
    x2: 11.4918,
    y2: 17.0814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0047 5.37093) rotate(-1.44239) scale(3.73411 1.5635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 3.82045,
    y1: 8.23605,
    x2: 16.5597,
    y2: 28.3411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.00323 10.1628) scale(8.29441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FB9DC1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#F59EC3",
    stopOpacity: 0.0730316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    stopColor: "#E2A0C8",
    stopOpacity: 0.1749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#C5A4D0",
    stopOpacity: 0.2938
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9BAADB",
    stopOpacity: 0.4256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#66B1E9",
    stopOpacity: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9818,
    stopColor: "#26B9FA",
    stopOpacity: 0.7172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.68353 13.2662) scale(9.21043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.93871 11.5944) rotate(-33.2504) scale(1.78394 1.18611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.68353 13.2662) scale(9.21043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 7.14148,
    y1: 12.2569,
    x2: 4.13038,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.71929 11.4375) rotate(-1.44239) scale(2.63085 1.10156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 12.8858,
    y1: 14.2762,
    x2: 23.1594,
    y2: 30.4899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.646 15.8304) scale(6.68912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FB9DC1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#F59EC3",
    stopOpacity: 0.0730316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    stopColor: "#E2A0C8",
    stopOpacity: 0.1749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#C5A4D0",
    stopOpacity: 0.2938
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9BAADB",
    stopOpacity: 0.4256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#66B1E9",
    stopOpacity: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9818,
    stopColor: "#26B9FA",
    stopOpacity: 0.7172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0011 18.3332) scale(7.42785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6012 16.993) rotate(-33.2462) scale(1.43861 0.956444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0011 18.3332) scale(7.42785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    stopColor: "#CBF0FF",
    stopOpacity: 0.1435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#B8EBFF",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#9BE2FE",
    stopOpacity: 0.5757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80DAFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 15.564,
    y1: 17.5189,
    x2: 13.1357,
    y2: 23.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8353 16.855) rotate(-1.44248) scale(2.12153 0.888355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles3);
export default __webpack_public_path__ + "static/media/bubbles3.1e2bf86002515cda76463750ec5962a7.svg";
export { ForwardRef as ReactComponent };